/**
 * Customer support contact card for iSmartPay.
 */

import React from 'react';
import { useTranslation } from 'react-i18next';

export const CUSTOMER_SUPPORT_PHONE_DISPLAY = '055 707 5426';
export const CUSTOMER_SUPPORT_PHONE_TEL = '+233557075426';
export const CUSTOMER_SUPPORT_EMAIL_DISPLAY = 'Customersupport@ismartghana.com';
export const CUSTOMER_SUPPORT_EMAIL_MAILTO = 'customersupport@ismartghana.com';

const CustomerSupportCard = ({ className = '' }) => {
  const { t } = useTranslation();

  return (
    <div className={`customer-support ${className}`.trim()}>
      <div className="customer-support__card">
        <div className="customer-support__header">
          <div className="customer-support__icon" aria-hidden="true">
            <span className="material-symbols-outlined">support_agent</span>
          </div>
          <div className="customer-support__intro">
            <h4 className="customer-support__title">
              {t('customerSupportTitle', {
                ns: 'settings',
                defaultValue: 'iSmartPay Customer Support',
              })}
            </h4>
            <p className="customer-support__subtitle">
              {t('customerSupportSubtitle', {
                ns: 'settings',
                defaultValue: 'Official support for your account, payments, and transactions.',
              })}
            </p>
          </div>
        </div>

        <div className="customer-support__methods">
          <a
            href={`tel:${CUSTOMER_SUPPORT_PHONE_TEL}`}
            className="customer-support__method"
            aria-label={t('callSupport', {
              ns: 'settings',
              defaultValue: 'Call support at {{phone}}',
              phone: CUSTOMER_SUPPORT_PHONE_DISPLAY,
            })}
          >
            <span className="customer-support__method-icon material-symbols-outlined" aria-hidden="true">
              call
            </span>
            <span className="customer-support__method-text">
              <span className="customer-support__method-label">
                {t('callUs', { ns: 'settings', defaultValue: 'Call us' })}
              </span>
              <span className="customer-support__method-value">{CUSTOMER_SUPPORT_PHONE_DISPLAY}</span>
            </span>
          </a>

          <a
            href={`mailto:${CUSTOMER_SUPPORT_EMAIL_MAILTO}`}
            className="customer-support__method"
            aria-label={t('emailSupport', {
              ns: 'settings',
              defaultValue: 'Email support at {{email}}',
              email: CUSTOMER_SUPPORT_EMAIL_DISPLAY,
            })}
          >
            <span className="customer-support__method-icon material-symbols-outlined" aria-hidden="true">
              mail
            </span>
            <span className="customer-support__method-text">
              <span className="customer-support__method-label">
                {t('emailUs', { ns: 'settings', defaultValue: 'Email us' })}
              </span>
              <span className="customer-support__method-value customer-support__method-value--email">
                {CUSTOMER_SUPPORT_EMAIL_DISPLAY}
              </span>
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default CustomerSupportCard;
